import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Modal, ModalBody, ModalHeader, Button, ButtonToolbar, Row, Col } from 'reactstrap';
import {fetchProgramFlatListAndDifference} from "@/shared/apiHelper"
import { Form, Field } from 'react-final-form';
import axios from 'axios'
import renderSelectField from '@/shared/components/form/Select';
import {labelizeNamedData} from '@/shared/helpers'
import {useDispatch, sendFlashMessage} from "@/shared/components/flash";
import CopySubProgramModal from './CopySubProgramModal';
import NewSubProgramModal from './NewSubProgramModal';
import '../components/style.scss';

const AddSubProgramModal = ({organization, program, isOpen, setOpen, toggle, theme, rtl, setTrigger}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [subprogramList, setSubprogramList] = useState(null)
    const [inventory, setInventory] = useState(null)
    const [initialValues, setInitialValues] = useState({direct_anscestor: {label: 'None', value: program.id}})
    const [isCopyOpen, setCopyOpen] = useState(false)
    const [isCreateOpen, setCreateOpen] = useState(false);
    const [copyingProgram, setCopyingProgram] = useState(null)
    const onClickStartCopyProgram = () => {
        setCopyingProgram(program.id)
        setCopyOpen(true)
    }

    const copyToggle = () => {
        setCopyOpen(prevState => !prevState);
    };

    const onClickCreateNewProgram = () => {
        setCreateOpen(true);
    }

    const createToggle = () => {
        setCreateOpen(prevState => !prevState);
    }

    const onSubmit = async(values) => {
        try {
            let formData = {
                parent_id: values.direct_anscestor.value
            }
            let program_to_add = values.sub_program.value
            setLoading( true )
            const response = await axios.patch(`/organization/${program.organization_id}/program/${program_to_add}/move`, formData);
            setLoading(false)
            if( response.status === 200)    {
                setOpen(false)
                dispatch(sendFlashMessage('Subprogram has been added', 'alert-success', 'top'))
                setTrigger( Math.floor(Date.now() / 1000) )
            }
        } catch (e) {
            setLoading(false)
            dispatch(sendFlashMessage('Subprogram could not be added', 'alert-danger', 'top'))
            throw new Error(`API error:${e?.message}`);
        }
    };
    useEffect( () => {
        if( organization && program )  {
            fetchProgramFlatListAndDifference(program.organization.id, program.id)
            .then( list => {
                if( list?.available )   {
                    setInventory(labelizeNamedData(list.available));
                }
                if( list?.subprograms )   {
                    let subprograms = labelizeNamedData(list.subprograms);
                    subprograms = [...[{label: 'None', value: program.id}], ...subprograms]
                    setSubprogramList(subprograms);
                }
            })
        }
    }, [organization, program])

    const validate = values => {
        let errors = {};
        if (!values.sub_program) {
            errors.sub_program = "Sub program is required";
        }
        if (!values.direct_anscestor) {
            errors.direct_anscestor = "Direct anscestor is required";
        }
        return errors;
    }

    return (<>
    <Modal className={`modal-program manager-program-modal modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
        <Form 
            onSubmit={onSubmit}
            validate={(values) => validate(values)}
            initialValues={initialValues}
        >
        {({ handleSubmit, form, submitting, pristine, values }) => (
        <form className="form form--horizontal" onSubmit={handleSubmit}>
            <ModalHeader tag="div" className="manager-program-modal__header">
                <div className="manager-program-modal__header-row">
                    <div className="manager-program-modal__header-copy">
                        <h3 className="manager-program-modal__title">Add Subprogram</h3>
                        <p className="manager-program-modal__subtitle">
                            Attach or create a child program under {program.name}.
                        </p>
                    </div>
                    <ButtonToolbar className="manager-program-modal__actions">
                        <Button outline color="primary" onClick={toggle}>Close</Button>
                    </ButtonToolbar>
                </div>  
            </ModalHeader>
         
            <ModalBody className="manager-program-modal__body">
              <div className="manager-program-modal__section">
              <Row>
                <Col md="6" >
                    <div className="form__form-group">
                        <span className="form__form-group-label">Select from the dropdown list to add as a subprogram :</span>
                        <div className="form__form-group-field">
                            <Field
                                name="sub_program"
                                component={renderSelectField}
                                options={inventory}
                            />
                        </div>
                    </div>
                </Col>
                <Col md="6" >
                    <div className="form__form-group">
                        <span className="form__form-group-label">Select from the dropdown list to add as a Direct Anscestor</span>
                        <div className="form__form-group-field">
                            <Field
                                name="direct_anscestor"
                                component={renderSelectField}
                                options={subprogramList}
                                // defaultValue={directAnscestor}
                            />
                        </div>
                    </div>
                </Col>
              </Row>
              </div>
              <Row className="mt-4">
                        <Col md="6" className='mt-4'>    
                            <Button 
                                outline 
                                onClick={onClickStartCopyProgram}
                                color="primary" 
                                className="mr-3" 
                            >
                                Clone an existing subprogram
                            </Button>
                        </Col>
                        <Col md="6" className='mt-4 text-right' style={{textAlign:'right'}} >   
                            <Button 
                                outline 
                                color="secondary" 
                                onClick={onClickCreateNewProgram}
                            >
                                Create a new subprogram
                            </Button>
                        </Col>
                    </Row>
                    <div className="manager-program-modal__footer-actions">
                        <Button type="submit" disabled={loading} className="btn btn-primary" color="#ffffff">
                            Add Subprogram
                        </Button>
                    </div>
            </ModalBody>
            </form>
        )}
        </Form>
    </Modal>
    {copyingProgram && <CopySubProgramModal subprogramList={subprogramList} isOpen={isCopyOpen} setOpen={setCopyOpen} toggle={copyToggle} program={program} />}
    
    <NewSubProgramModal data={program} isOpen={isCreateOpen} toggle={createToggle} />
    </>
    )
}
AddSubProgramModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};
  
export default (connect((state) => ({
    theme: state.theme,
    rtl: state.rtl
}))(AddSubProgramModal));
